/* eslint-env browser */
import { Component, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, input, output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Customer } from '@app/models/customers/Customer';
import { FlightOffer } from '@app/models/offerpack/FlightOffer';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { ImportService } from '@app/services/import.service';
import moment from 'moment-timezone';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommentComponent } from '../comment/comment.component';
import { FlightDetailComponent } from '../offerpackdetailmodal/flight-detail/flight-detail.component';
import { OfferpackDetailPersComponent } from '../offerpackdetailmodal/offerpack-detail-pers/offerpack-detail-pers.component';

@Component({
    selector: 'app-offerpackftiticketshopcard',
    templateUrl: './offerpackftiticketshopcard.component.html',
    styleUrls: ['./offerpackftiticketshopcard.component.scss'],
    standalone: false
})
export class OfferpackftiticketshopcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    readonly offerid = input<string>(undefined);
    readonly mitEmail = input<string>(undefined);
    readonly index = input<number>(undefined);
    readonly mitName = input<string>(undefined);
    readonly mitTel = input<string>(undefined);
    readonly packid = input<string>(undefined);
    readonly online = input<string>(undefined);
    readonly removeFromList = output<string>();
    readonly changeindex = output<{
    dragedindex: number;
    dropindex: number;
}>();

    currentCustomer: Customer;
    currentpartner: Partner;

    datas: FlightOffer;
    component: ComponentRef<any>;
    sendRegSub: Subscription;
    sendBack: Subscription;
    showDetail: boolean = false;

    showHinflug: boolean = false;
    showRuckflug: boolean = false;

    desktopTemplate: string = 'xl';
    constructor(
        private auth: AuthService,
        private authguad: AuthGuardService,
        private ftiflyService: ImportService,
        private acvisService: AcvisService,
        private cdr: ChangeDetectorRef,
        private viewContainerRef: ViewContainerRef,
        private dialog: MatDialog,
        protected mediaObserver: BreakpointObserver
    ) { }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
        if (this.component) {
            this.component.destroy();
        }
        if (this.sendRegSub) {
            this.sendRegSub.unsubscribe();
        }
        if (this.sendBack) {
            this.sendBack.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.initMedia();
        this.initCustomer();
        this.initPartner();
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    async initPartner() {
        this.authguad.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    initData() {
        const target = {
            offerid: this.offerid(),
            partnerid: this.currentpartner?.partnerid
        };
        this.ftiflyService.request(target, 'getofferbyid').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                this.datas = {} as FlightOffer;
                if (res?.CustomOffer?.Flights?.Flight) {
                    this.initDataPax(res);
                } else if (res?.CustomOffer?.detailFareList) {
                    this.initDataOfferpack(res);
                }
            }
        });
    }

    async initDataPax(res) {
        this.datas.hinflugs = [];
        this.datas.ruckflugs = [];
        this.datas.extracomment = res.extracomment;
        this.datas.validTo = res?.CustomOffer?.ValidTo;
        this.datas.backReference = res?.CustomOffer?.BackReference;
        this.datas.adult = (Number(res?.CustomOffer?.PAX) - (!isNaN(Number(res?.CustomOffer?.ChildrenCount)) ? Number(res?.CustomOffer?.ChildrenCount) : 0)) + '';
        this.datas.type = res?.CustomOffer?.OfferSource;
        this.datas.childrenCount = res?.CustomOffer?.ChildrenCount;
        this.datas.children = res?.CustomOffer?.Children;
        this.datas.pax = res?.CustomOffer?.PAX;
        this.cdr.detectChanges();
        this.initFlightPaxInfo(res);
    }

    async initFlightPaxInfo(res) {
        const aircodes = [];
        if (res?.CustomOffer?.Flights?.Flight && !Array.isArray(res?.CustomOffer?.Flights?.Flight)) {
            res.CustomOffer.Flights.Flight = [res.CustomOffer.Flights.Flight];
        }
        if (res?.CustomOffer?.Flights?.Flight?.length > 0) {
            for (let i = 0; i < res.CustomOffer.Flights.Flight.length; i++) {
                // init Price
                if (res.CustomOffer.Flights.Flight[i].Price?.length > 0) {
                    this.datas.price = res.CustomOffer.Flights.Flight[i].Price;
                    this.datas.currency = res.CustomOffer.Flights.Flight[i].Currency;
                }

                if (res?.CustomOffer?.Flights?.Flight[i]?.FlightType === 'Outward') {
                    this.datas.hinflugs.push({
                        startDate: res.CustomOffer.Flights.Flight[i].StartDate,
                        endDate: res.CustomOffer.Flights.Flight[i].EndDate,
                        flightNumber: res.CustomOffer.Flights.Flight[i].FlightNumber,
                        flightType: res.CustomOffer.Flights.Flight[i].FlightType,
                        carrier: res.CustomOffer.Flights.Flight[i].Carrier,
                        dauer: '',
                        plusDay: moment(res.CustomOffer.Flights.Flight[i].EndDate, 'YYYY-MM-DD').diff(moment(res.CustomOffer.Flights.Flight[i].StartDate, 'YYYY-MM-DD'), 'days'),
                        cabinClass: res.CustomOffer.Flights.Flight[i].FlightClass,
                        departureAirport: {
                            name: '',
                            code: res.CustomOffer.Flights.Flight[i].DepartureAirportIATA
                        },
                        arrivalAirport: {
                            name: '',
                            code: res.CustomOffer.Flights.Flight[i].ArrivalAirportIATA
                        },
                        gepack: res.CustomOffer.Flights.Flight[i].ServiceDescription
                    });

                    if (res?.CustomOffer?.Flights?.Flight[i + 1]?.FlightType === 'Outward') {
                        this.datas.hinflugs[this.datas.hinflugs.length - 1].waitTime = moment(moment(res.CustomOffer.Flights.Flight[i + 1].StartDate).diff(moment(this.datas.hinflugs[this.datas.hinflugs.length - 1].endDate))).format('HH:mm');
                    }
                }
                if (res?.CustomOffer?.Flights?.Flight[i]?.FlightType === 'Inward') {
                    this.datas.ruckflugs.push({
                        startDate: res.CustomOffer.Flights.Flight[i].StartDate,
                        endDate: res.CustomOffer.Flights.Flight[i].EndDate,
                        flightNumber: res.CustomOffer.Flights.Flight[i].FlightNumber,
                        flightType: res.CustomOffer.Flights.Flight[i].FlightType,
                        carrier: res.CustomOffer.Flights.Flight[i].Carrier,
                        cabinClass: res.CustomOffer.Flights.Flight[i].FlightClass,
                        dauer: '',
                        plusDay: moment(res.CustomOffer.Flights.Flight[i].EndDate, 'YYYY-MM-DD').diff(moment(res.CustomOffer.Flights.Flight[i].StartDate, 'YYYY-MM-DD'), 'days'),
                        departureAirport: {
                            name: '',
                            code: res.CustomOffer.Flights.Flight[i].DepartureAirportIATA
                        },
                        arrivalAirport: {
                            name: '',
                            code: res.CustomOffer.Flights.Flight[i].ArrivalAirportIATA
                        },
                        gepack: res.CustomOffer.Flights.Flight[i].ServiceDescription
                    });

                    if (res?.CustomOffer?.Flights?.Flight[i + 1]?.FlightType === 'Inward') {
                        this.datas.ruckflugs[this.datas.ruckflugs.length - 1].waitTime = moment(moment(res.CustomOffer.Flights.Flight[i + 1].StartDate).diff(moment(this.datas.ruckflugs[this.datas.ruckflugs.length - 1].endDate))).format('HH:mm');
                    }
                }
                if (aircodes.indexOf(res.CustomOffer.Flights.Flight[i].DepartureAirportIATA) < 0) {
                    aircodes.push(res.CustomOffer.Flights.Flight[i].DepartureAirportIATA);
                }
                if (aircodes.indexOf(res.CustomOffer.Flights.Flight[i].ArrivalAirportIATA) < 0) {
                    aircodes.push(res.CustomOffer.Flights.Flight[i].ArrivalAirportIATA);
                }
            }
            if (this.datas.hinflugs?.length > 0 && this.datas.ruckflugs.length > 0) {
                const date1 = moment(this.datas.hinflugs[0].startDate);
                const date2 = moment(this.datas.ruckflugs[0].startDate);
                // console.log(date1)
                // console.log(date2)
                this.datas.dauer = date2.diff(date1, 'days');
            }
            this.cdr.detectChanges();
            this.getAirport(aircodes);
            this.calculDuration(aircodes);
        }

        this.cdr.detectChanges();
    }

    async initDataOfferpack(res) {
        this.datas.hinflugs = [];
        this.datas.ruckflugs = [];
        this.datas.extracomment = res.extracomment;
        this.datas.validTo = res?.CustomOffer?.ValidTo;
        this.datas.backReference = res?.CustomOffer?.BackReference;
        this.datas.type = res?.CustomOffer?.OfferSource;
        this.cdr.detectChanges();

        this.initPaxInfo(res);
        this.initFlightInfo(res);

        this.datas.price = res?.CustomOffer?.detailFareList?.element?.total;
        this.datas.currency = res?.CustomOffer?.currencyIsoCode;
        // console.log(this.datas);
    }

    async initPaxInfo(res) {
        if (res?.CustomOffer?.detailFareList?.element?.priceDetails?.element && !Array.isArray(res?.CustomOffer?.detailFareList?.element?.priceDetails?.element)) {
            res.CustomOffer.detailFareList.element.priceDetails.element = [res.CustomOffer.detailFareList.element.priceDetails.element];
        }
        let pax = 0;
        for (let i = 0; i < res.CustomOffer.detailFareList.element.priceDetails.element.length; i++) {
            if (res.CustomOffer.detailFareList.element.priceDetails.element[i].type === 'ADT') {
                this.datas.adult = res.CustomOffer.detailFareList.element.priceDetails.element[i].paxCount;
                pax += Number(this.datas.adult);
                this.datas.pricePerAdult = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3PerPax;
                this.datas.priceTotalAdult = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3;
            } else if (res.CustomOffer.detailFareList.element.priceDetails.element[i].type === 'CHD') {
                this.datas.childrenCount = res.CustomOffer.detailFareList.element.priceDetails.element[i].paxCount;
                pax += Number(this.datas.childrenCount);
                this.datas.pricePerChildren = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3PerPax;
                this.datas.priceTotalChildren = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3PerPax;
            } else if (res.CustomOffer.detailFareList.element.priceDetails.element[i].type === 'INF') {
                this.datas.infantcount = res.CustomOffer.detailFareList.element.priceDetails.element[i].paxCount;
                pax += Number(this.datas.infantcount);
                this.datas.pricePerInfant = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3PerPax;
                this.datas.priceTotalInfant = res.CustomOffer.detailFareList.element.priceDetails.element[i].subTotalWithoutPaymentFeesMarkup2AndMarkup3PerPax;
            }
        }

        this.datas.pax = pax + '';
        this.cdr.detectChanges();
    }

    async initFlightInfo(res) {
        const aircodes = [];
        for (let i = 0; i < res?.CustomOffer?.detailFareList?.element?.legList?.element?.length; i++) {
            if (res.CustomOffer.detailFareList.element.legList.element[i].direction === 'outbound') {
                if (res.CustomOffer.detailFareList.element.legList.element[i]?.itineraryList?.element?.segmentList?.element &&
                    !Array.isArray(res.CustomOffer.detailFareList.element.legList.element[i]?.itineraryList?.element?.segmentList?.element)) {
                    res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element = [res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element];
                }

                for (let j = 0; j < res.CustomOffer.detailFareList.element?.legList.element[i].itineraryList?.element?.segmentList?.element?.length; j++) {
                    this.datas.hinflugs.push({
                        startDate: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp,
                        endDate: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp,

                        flightNumber: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].flightNumber,
                        flightType: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].type,

                        dauer: moment(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp)
                            .diff(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp))).format('HH:mm'),
                        plusDay: moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp, 'YYYY-MM-DD')
                            .diff(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp, 'YYYY-MM-DD'), 'days'),

                        carrier: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].operatingAirline?.name,
                        cabinClass: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].cabinClass,
                        departureAirport: {
                            name: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.name,
                            code: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code
                        },
                        arrivalAirport: {
                            name: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.name,
                            code: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code
                        },
                        gepack: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].baggageAllowance
                    });
                    if (res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j + 1]) {
                        this.datas.hinflugs[this.datas.hinflugs.length - 1].waitTime = moment(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j + 1].departureTimestamp)
                            .diff(moment(this.datas.hinflugs[this.datas.hinflugs.length - 1].endDate))).format('HH:mm');
                    }

                    if (aircodes.indexOf(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code) < 0) {
                        aircodes.push(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code);
                    }
                    if (aircodes.indexOf(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code) < 0) {
                        aircodes.push(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code);
                    }
                }
            } else if (res.CustomOffer.detailFareList.element.legList.element[i].direction === 'inbound') {
                if (res.CustomOffer.detailFareList.element.legList.element[i]?.itineraryList?.element?.segmentList?.element &&
                    !Array.isArray(res.CustomOffer.detailFareList.element.legList.element[i]?.itineraryList?.element?.segmentList?.element)) {
                    res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element = [res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element];
                }

                for (let j = 0; j < res.CustomOffer.detailFareList.element?.legList.element[i].itineraryList?.element?.segmentList?.element?.length; j++) {
                    this.datas.ruckflugs.push({
                        startDate: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp,
                        endDate: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp,

                        flightNumber: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].flightNumber,
                        flightType: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].type,

                        dauer: moment(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp)
                            .diff(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp))).format('HH:mm'),
                        plusDay: moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].arrivalTimestamp, 'YYYY-MM-DD')
                            .diff(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departureTimestamp, 'YYYY-MM-DD'), 'days'),

                        carrier: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].operatingAirline?.name,
                        cabinClass: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].cabinClass,
                        departureAirport: {
                            name: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.name,
                            code: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code
                        },
                        arrivalAirport: {
                            name: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.name,
                            code: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code
                        },
                        gepack: res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].baggageAllowance
                    });
                    if (res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j + 1]) {
                        this.datas.ruckflugs[this.datas.ruckflugs.length - 1].waitTime = moment(moment(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j + 1].departureTimestamp)
                            .diff(moment(this.datas.ruckflugs[this.datas.ruckflugs.length - 1].endDate))).format('HH:mm');
                    }

                    if (aircodes.indexOf(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code) < 0) {
                        aircodes.push(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].departure?.code);
                    }
                    if (aircodes.indexOf(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code) < 0) {
                        aircodes.push(res.CustomOffer.detailFareList.element.legList.element[i].itineraryList.element.segmentList.element[j].destination?.code);
                    }
                }
            }
        }

        if (this.datas.hinflugs?.length > 0 && this.datas.ruckflugs.length > 0) {
            const date1 = moment(this.datas.hinflugs[0].startDate);
            const date2 = moment(this.datas.ruckflugs[0].startDate);
            // console.log(date1)
            // console.log(date2)
            this.datas.dauer = date2.diff(date1, 'days');
        }
        this.calculDuration(aircodes);
        this.cdr.detectChanges();
    }

    getAirport(aircodes) {
        this.acvisService.request({ codes: aircodes }, 'airoportList').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            this.initAirpotName(data);
        });
    }

    calculDuration(aircodes) {
        this.acvisService.request({ codes: aircodes }, 'getAirportsWithTimezone').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((array) => {
            this.calculationDauer(array, this.datas.hinflugs);
            this.calculationDauer(array, this.datas.ruckflugs);
            this.cdr.detectChanges();
        });
    }

    calculationDauer(array, flugs) {
        if (array?.length > 0) {
            for (let i = 0; i < flugs.length; i++) {
                const zoneStart = this.gettimeZone(array, flugs[i].departureAirport.code);
                const zoneEnd = this.gettimeZone(array, flugs[i].arrivalAirport.code);
                const d = moment.duration(moment.tz(flugs[i].endDate, zoneEnd).diff(moment.tz(flugs[i].startDate, zoneStart)));
                flugs[i].dauer = String(d.hours()).padStart(2, '0') + ':' + String(d.minutes()).padStart(2, '0');
            }
        }
    }

    gettimeZone(array, code): string {
        for (let i = 0; i < array.length; i++) {
            if (array[i].iata === code) {
                return array[i].tz;
            }
        }

        return '';
    }

    async initAirpotName(data) {
        for (let j = 0; j < data.length; j++) {
            for (let i = 0; i < this.datas.hinflugs.length; i++) {
                if (data[j].code === this.datas.hinflugs[i].departureAirport?.code) {
                    this.datas.hinflugs[i].departureAirport.name = data[j].name;
                }
                if (data[j].code === this.datas.hinflugs[i].arrivalAirport.code) {
                    this.datas.hinflugs[i].arrivalAirport.name = data[j].name;
                }
            }
            for (let i = 0; i < this.datas.ruckflugs.length; i++) {
                if (data[j].code === this.datas.ruckflugs[i].departureAirport.code) {
                    this.datas.ruckflugs[i].departureAirport.name = data[j].name;
                }
                if (data[j].code === this.datas.ruckflugs[i].arrivalAirport.code) {
                    this.datas.ruckflugs[i].arrivalAirport.name = data[j].name;
                }
            }
        }
        this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async gotoBuchen() {
        if (this.currentCustomer?.token?.length > 0) {
            window.open(this.datas?.backReference, '_blank', 'noopener');
        } else {
            this.openDetail();
        }
    }

    checkHinflug(ev) {
        ev.stopPropagation();
        this.showHinflug = !this.showHinflug;
        this.cdr.detectChanges();
    }

    checkRuckflug(ev) {
        ev.stopPropagation();
        this.showRuckflug = !this.showRuckflug;
        this.cdr.detectChanges();
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(FlightDetailComponent); // FlightDetailComponent
        this.component.instance.datas = this.datas;
        this.component.instance.id = this.index();
        this.sendRegSub = this.component.instance.sendReg.subscribe((ev) => {
            if (ev) {
                this.setPersComponent();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    async setPersComponent() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendBack?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(OfferpackDetailPersComponent); // FlightDetailComponent
        this.component.instance.datas = this.datas;
        this.component.instance.id = this.index();
        this.component.instance.type = 'flight';
        this.component.instance.mitEmail = this.mitEmail();
        this.component.instance.mitName = this.mitName();
        this.component.instance.mitTel = this.mitTel();
        this.component.instance.packid = this.packid();
        this.component.instance.offerid = this.offerid();
        this.sendBack = this.component.instance.goBack.subscribe((ev) => {
            if (ev) {
                this.openDetail();
            }
        });
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.datas.extracomment = data?.message;
                this.saveComment(this.datas.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid(),
            extracomment: extracomment,
            partnerid: this.currentpartner?.partnerid
        };
        this.ftiflyService.request(target, 'saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
